// extracted by mini-css-extract-plugin
export default {"truckGrid":"style_truckGrid__bprBW"};